function closeModal(modal_id, to_anchor) {
    $('#' + modal_id).modal('hide');
    if (to_anchor) document.location.href = '#car_selector_anchor';
}

function setModalRimName(rim_name) {
    $('#modal_rim_name').html(rim_name);
    $('#rim1_modal').modal('show');
}